NtechApp.AjaxPolling = function() {
    var me = this;

    this._ajax = null;

    this._nextPullRequestTimeoutHandle = null;

    this._pullRequestTimeout = null;
    this._lastSiteActivity = null;
    this._lastPullRequestTimeout = null;
    this._isInactivePollingFrequencyOn = false;

    this._isPullRequestActive = false;
    this._pullRequestParams = {};
    this._pullRequestParamResolvers = [];

    this._isForcedPullRequestScheduled = false;
    this._forcedPullRequestCallbacks = [];

    this._construct = function () {
        me._ajax = new NtechApp.Ajax();

        me._pullRequestTimeout = NtechApp.AjaxPolling.DEFAULT_PULL_REQUEST_SECONDS_DELAY * 1000;
        me._lastSiteActivity = new Date();

        me._scheduleNextPullUpdatesRequest();

        me._bindEvents();
    }

    this._bindEvents = function () {
        var processAppActivity = function() {
            me._lastSiteActivity = new Date();
            me._restoreActivePollingIfWasInactive();
        };

        $(document).on("scroll.NtechApp.AjaxPooling", function() {
            processAppActivity();
        });

        $("body").on("click.NtechApp.AjaxPooling", function() {
            processAppActivity();
        });

        $("body").on("touchend.NtechApp.AjaxPooling", function() {
            processAppActivity();
        });

        $("body").on("mousemove.NtechApp.AjaxPooling", function() {
            processAppActivity();
        });
    }

    this._unbindEvents = function () {
        ;
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.AjaxPolling.EVENT_ON_DATA_PULL = "NtechApp.AjaxPolling.EventOnDataPull";

NtechApp.AjaxPolling.DEFAULT_PULL_REQUEST_SECONDS_DELAY = 1;
NtechApp.AjaxPolling.INACTIVE_PULL_REQUEST_SECONDS_DELAY = 10;
NtechApp.AjaxPolling.IS_APP_INACTIVE_SECONDS_DELAY = 5;

NtechApp.proto(NtechApp.AjaxPolling, {
    _getPullUpdatesRoute: function() {
        if(NtechApp.clientSettings.isPersonal)
            return 'personal_pull_updates';
        else if(NtechApp.clientSettings.isBusiness)
            return 'business_pull_updates';
    },

    addPullRequestParamsResolver: function(fn) {
        this._pullRequestParamResolvers.push(fn);
    },

    _resolvePullRequestParams: function() {
        var computedParams = {};
        for(var prop in this._pullRequestParams)
            computedParams[prop] = this._pullRequestParams[prop];

        for(var i = 0; i < this._pullRequestParamResolvers.length; i++) {
            var params = this._pullRequestParamResolvers[i]();
            for(var prop in params)
                computedParams[prop] = params[prop];
        }

        return computedParams;
    },

    setCustomPollingFrequencyInSeconds: function(delay) {
        this._lastSiteActivity = new Date();
        this._restoreActivePollingIfWasInactive();
        this._pullRequestTimeout = delay * 1000;

        clearTimeout(this._nextPullRequestTimeoutHandle);
        this._scheduleNextPullUpdatesRequest();
    },

    restoreDefaultPollingFrequency: function() {
        this._lastSiteActivity = new Date();
        this._restoreActivePollingIfWasInactive();
        this._pullRequestTimeout = NtechApp.AjaxPolling.DEFAULT_PULL_REQUEST_SECONDS_DELAY * 1000;

        clearTimeout(this._nextPullRequestTimeoutHandle);
        this._scheduleNextPullUpdatesRequest();
    },

    _isAppInactiveTooLong: function() {
        var now = new Date();

        var diff = now.getTime() - this._lastSiteActivity.getTime();
        var maxDiff = NtechApp.AjaxPolling.IS_APP_INACTIVE_SECONDS_DELAY * 1000;

        return (diff > maxDiff);
    },

    _setupInactivePollingFrequency: function() {
        this._lastPullRequestTimeout = this._pullRequestTimeout;
        this._isInactivePollingFrequencyOn = true;

        this._pullRequestTimeout = NtechApp.AjaxPolling.INACTIVE_PULL_REQUEST_SECONDS_DELAY * 1000;
    },

    _restoreActivePollingIfWasInactive: function() {
        var me = this;
        if(me._isInactivePollingOn()) {
            me._restoreActivePollingFrequency();

            clearTimeout(me._nextPullRequestTimeoutHandle);
            me._scheduleNextPullUpdatesRequest();
        }
    },

    _restoreActivePollingFrequency: function() {
        this._pullRequestTimeout = this._lastPullRequestTimeout;
        this._isInactivePollingFrequencyOn = false;
    },

    _isInactivePollingOn: function() {
        return this._isInactivePollingFrequencyOn;
    },

    forceNextPullRequest: function(cb) {
        clearTimeout(this._nextPullRequestTimeoutHandle);

        if(typeof cb == "function")
            this._forcedPullRequestCallbacks.push(cb);

        this._isForcedPullRequestScheduled = true;
        this._execNextPullRequest();
    },

    _scheduleNextPullUpdatesRequest: function() {
        var me = this;
        if(this._isAppInactiveTooLong() && !this._isInactivePollingOn())
            this._setupInactivePollingFrequency();

        if(!me._isForcedPullRequestScheduled) {
            me._nextPullRequestTimeoutHandle = setTimeout(function () {
                me._execNextPullRequest();
            }, this._pullRequestTimeout);
        }
        else {
            me._execNextPullRequest();
        }
    },

    _execNextPullRequest: function() {
        var me = this;

        if(me._isPullRequestActive)
            return;

        me._isForcedPullRequestScheduled = false;
        me._isPullRequestActive = true;

        me._execPullUpdatesRequest.call(me);
    },

    _execPullUpdatesRequest: function() {
        var me = this;

        me._ajax.get({
            url: Routing.generate(me._getPullUpdatesRoute(), this._resolvePullRequestParams()),
            onSuccess: function(data) {
                $(me).trigger(NtechApp.AjaxPolling.EVENT_ON_DATA_PULL, [data]);

                for(var i = 0; i < me._forcedPullRequestCallbacks.length; i++)
                    me._forcedPullRequestCallbacks[i](data);
                me._forcedPullRequestCallbacks = [];

                me._isPullRequestActive = false;
                me._scheduleNextPullUpdatesRequest();
            },
            onComplete: function() {
                ;
            }
        });
    }
});